export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <a className={`brand ${compact ? "brand--compact" : ""}`} href="/">
      <span className="brand__word">Vaffangoogle</span>
    </a>
  );
}
